import { protobomp_utils_entity_create_assembly, protobomp_utils_entity_create_primitive } from "../utils/frfr-protobomp-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { _smartbom_manipulator_count_draftels_where_draftelschemakey, _smartbom_manipulator_get_children_smartel_arr, _smartbom_validator_quick_incomplete } from "../utils/frfr-smartbom-utils";
import { DOT } from "../utils/frfr-string-consts";
import { ROUND, ROUNDUP } from "../utils/excel-functions-utils";
import { users_cache_get } from "./ter-cache-utils";
import tclocal from "./ter-consts-local-lib";
import { _getParamsFromLibMaterijalLimParams } from "./ter-materijal-utils";
import { _getVentilatorSingleFromLib } from "./ter-params-utils";


//
export const terUtilsPrepareEntboxForSubmit = (state) => {
  // TODO submit raznih stvari iz statea forme
  return state;
};


//
export const terUtilsPrepareDraftelForSubmit = (state, podsInputWidgetPack) => {
  if (js_utils.is_object(podsInputWidgetPack)) {
    // novi pods_input mehanizam
    const {
      flag_custom_pods_input,
      pods_input,
    } = podsInputWidgetPack;
    console.log('***** prepare draftel for SUBMIT with podsInputWidgetPack', podsInputWidgetPack);
    const state2 = {
      ...state,
      ...pods_input,
      flag_custom_pods_input
    };
    delete state2.virtelschemakey; // virtelschemakey nikako ne sme u draftel i formu da ide
    Object.keys(state2).forEach((key) => {
      if (typeof key === 'string' && key.startsWith('_temp_')) {
        delete state2[key]; // brise svaki properti koji pocinje sa _temp
      }
    });
    return state2;
  } else {
    const state2 = {
      ...state
    };
    delete state2.virtelschemakey; // virtelschemakey nikako ne sme u draftel i formu da ide
    Object.keys(state2).forEach((key) => {
      if (typeof key === 'string' && key.startsWith('_temp_')) {
        delete state2[key]; // brise svaki properti koji pocinje sa _temp
      }
    });
    return state2;
  }
  ///////
  /*
  let entbox = {
    ...state
  };
  delete entbox._frontendTrackingId;
  return entbox;
  */
};


export const terUtilsUnitsMilimetriToMetri = (mm, decimal_places) => {
  if (!(decimal_places > 0)) {
    decimal_places = 3; // materijali koji su u metrima kolicina se zaokruzuje na 3 decimale po default.
  }
  return ROUNDUP(mm / 1000, decimal_places); // koristimo excelovu ROUNDUP funkciju jer zelimo da izbegeno zaokruzivanje na manji broj  i manjak materijala
};
export const terUtilsUnitsMilimetriKvadratniToMetriKvadratni = (mm2, decimal_places) => {
  // console.log('mm2', mm2);
  if (!(decimal_places > 0)) {
    decimal_places = 2; // materijali koji su u kvadratnim metrima kolicina se zaokruzuje na 2 decimale po default.
  }
  let result = ROUNDUP(mm2 / 1000000, decimal_places); // koristimo excelovu ROUNDUP funkciju jer zelimo da izbegeno zaokruzivanje na manji broj  i manjak materijala
  // console.log('result', result);
  return result;
};

export const terUtilsNumberRoundClassic = (n, decimal_places) => {
  // zaokruzi na odredjeni broj decimala na klasičan način.
  // Ova funkcija nece dodati decimalna mesta, ukoliko je n integer ostace integer. Ukoliko na primer broj nakon zaokruzivanja ima samo jednu decimalu a mi smo zadali zaokruzivanje na 2 ipak ce ostati ta 1 decimala.
  return ROUND(n, decimal_places);
};

export const terUtilsNumberRoundUp = (n, decimal_places) => {
  // zaokruzi na odredjeni broj decimala
  // Ova funkcija nece dodati decimalna mesta, ukoliko je n integer ostace integer. Ukoliko na primer broj nakon zaokruzivanja ima samo jednu decimalu a mi smo zadali zaokruzivanje na 2 ipak ce ostati ta 1 decimala,  
  if (decimal_places === 0 || decimal_places > 0) {
    let result = ROUNDUP(n, decimal_places); // koristimo excelovu ROUNDUP funkciju jer zelimo da izbegeno zaokruzivanje na manji broj i manjak materijala. Dakle pri zaorkuzivanju se dobija isti ili veci broj.
    // console.log('result', result);
    return result;
  } else {
    // ukoliko je drugi argument zaboravljen vracamo neizmenjen broj
    return n;
  }
};


export const terUtils_izracunaj_povrsinu_materijala_lim = (sirina, duzina, sirinadodatak, duzinadodatak) => {
  // sirina i duzina su u mm
  let _sirina = 0;
  let _duzina = 0;
  if (js_utils.is_number(sirina)) {
    if (sirinadodatak > 0) {
      _sirina = sirina + sirinadodatak;
    } else {
      _sirina = sirina;
    }
  }
  if (js_utils.is_number(duzina)) {
    if (sirinadodatak > 0) {
      _duzina = duzina + duzinadodatak;
    } else {
      _duzina = duzina;
    }
  }
  const povrsina = terUtilsNumberRoundUp(((_sirina * _duzina) / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale
  return povrsina;
};


export const terUtils_get_naziv_materijala_by_ident = (identmaterijala) => {
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(identmaterijala); // primer LBJAR00A ili LBJAR00D
  let naziv_materijala = '';
  if (typeof _mat_params.naziv === 'string') {
    naziv_materijala = _mat_params.naziv;
  }
  return naziv_materijala;
};


//
export const terUtils_extract_masa_po_jm_from_virtel = (virtel) => {
  //
  let masa_po_jm = 0;
  if (virtel) {
    let not_found = true;
    if (virtel.masa_po_jm > 0) {
      // try 1) materijal
      masa_po_jm = virtel.masa_po_jm;
      not_found = false;
    }
    if (not_found) {
      if (virtel.flag_masa_po_jm_custom === true && virtel.masa_po_jm_custom > 0) {
        // try 2) masa_po_jm_custom
        masa_po_jm = virtel.masa_po_jm_custom;
        not_found = false;
      }
    }
    if (not_found) {
      if (js_utils.is_string_not_empty(virtel.calculated_ident)) {
        // try 3) by ident from material lib
        if (virtel.terkategorija === "M" || virtel.terkategorija === "OP") {
          // 2025-03-21: Samo ukoliko je materijal ili oprema u pitanju (sve osim "PP")
          const identmaterijala = virtel.calculated_ident;
          const _mat_params = _getParamsFromLibMaterijalLimParams(identmaterijala); // primer LBJAR00A ili LBJAR00D
          if (_mat_params.masa_po_jm > 0) {
            masa_po_jm = _mat_params.masa_po_jm;
            not_found = false;
          }
        }
      }
    }
    if (not_found) {
      // try 4) by ventilator ident
      if (js_utils.is_string_not_empty(virtel.identcustom)) {
        // console.log('virtel.identcustom', virtel.identcustom);
        const ventilator_params = _getVentilatorSingleFromLib(virtel.identcustom);
        // console.log('ventilator_params', ventilator_params);
        if (ventilator_params && ventilator_params.Tip_Ventilatora && ventilator_params.Masa_kg) {
          const _Masa_kg = Number.parseFloat(ventilator_params.Masa_kg);
          // console.log('_Masa_kg', _Masa_kg);
          if (_Masa_kg > 0) {
            // masa_po_jm = _Masa_kg * 1000; // pretvaranje kg u grame
            masa_po_jm = _Masa_kg; // nema konverzije jer se sada kao jedinica za masu se koristi kilogram (kg) svugde.
          }
        }
      }
    }
  }
  return masa_po_jm;
};


//
export const terUtils_extract_cena_po_jm_from_virtel = (virtel) => {
  //
  let cena_po_jm = 0;
  if (virtel) {
    let not_found = true;
    if (virtel.cena_po_jm > 0) {
      // try 1) materijal
      cena_po_jm = virtel.cena_po_jm;
      not_found = false;
    }
    if (not_found) {
      if (virtel.flag_cena_po_jm_custom === true && virtel.cena_po_jm_custom > 0) {
        // try 2) cena_po_jm_custom
        cena_po_jm = virtel.cena_po_jm_custom;
        not_found = false;
      }
    }
    if (not_found) {
      if (js_utils.is_string_not_empty(virtel.calculated_ident)) {
        // try 3) by ident from material lib
        if (virtel.terkategorija === "M" || virtel.terkategorija === "OP") {
          // 2025-03-21: Samo ukoliko je materijal ili oprema u pitanju (sve osim "PP")
          const identmaterijala = virtel.calculated_ident;
          const _mat_params = _getParamsFromLibMaterijalLimParams(identmaterijala); // primer LBJAR00A ili LBJAR00D
          if (_mat_params.cena_po_jm > 0) {
            cena_po_jm = _mat_params.cena_po_jm;
            not_found = false;
          }
        }
      }
    }
    if (not_found) {
      // try 4) by ventilator ident
      if (js_utils.is_string_not_empty(virtel.identcustom)) {
        // console.log('virtel.identcustom', virtel.identcustom);
        const ventilator_params = _getVentilatorSingleFromLib(virtel.identcustom);
        // console.log('ventilator_params', ventilator_params);
        if (ventilator_params && ventilator_params.Tip_Ventilatora && ventilator_params.cena_po_jm) {
          const _cena_po_jm = Number.parseFloat(ventilator_params.cena_po_jm);
          // console.log('_Masa_kg', _Masa_kg);
          if (_cena_po_jm > 0) {
            // cena_po_jm = _Masa_kg * 1000; // pretvaranje kg u grame
            cena_po_jm = _cena_po_jm; // TODO nema konverzije jer
          }
        }
      }
    }
  }
  return cena_po_jm;
};


export const terUtilsMultilevelNumberingTrim = (str) => {
  if (typeof str === 'string') {
    let _str = str.trim();
    while (_str.slice(-1) === DOT) {
      _str = _str.substring(0, _str.length - 1);
    }
    return _str;
  } else {
    return str;
  }
};

// ...GetIdent... funkcije
export const terUtilsGetIdentDemper = (d) => {
  let ident = '';

  let tipDempera = '';
  let sirinaDempera = '';
  let visinaDempera = '';
  let pogonDempera = '';
  let osovinaDempera = '';


  // ="DEM"&IF(I2="STANDARDNI",1,"?")&IF(I3<1000,"0"&I3,I3)&IF(I4<1000,"0"&I4,I4)&IF(I5="RUCNI","R",IF(I5="MOTORNI","M","?"))&IF(I6="75 mm","75",IF(I6="135 mm","135","?"))


  // console.log('DEMPER ', d);

  if (d.tipdempera && d.tipdempera === 'standardni') {
    tipDempera = 1;
  }

  if (d.unutrasnjasirina) {
    sirinaDempera = d.unutrasnjasirina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    sirinaDempera = ('0000' + sirinaDempera).slice(-4);
  }

  if (d.visina) {
    visinaDempera = d.visina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    visinaDempera = ('0000' + visinaDempera).slice(-4);
  }

  if (d.vrstapogona) {
    if (d.vrstapogona === 'motorni') {
      pogonDempera = 'M';
    } else {
      pogonDempera = 'R';
    }
  }

  if (d.osovina) {
    if (d.osovina.toString() === '75') {
      osovinaDempera = 75;
      /*
    } else {
      osovinaDempera = 135;
    }
    */
    } else if (d.osovina.toString() === '110') {
      osovinaDempera = 110;
    } else if (d.osovina.toString() === '135') {
      osovinaDempera = 135;
    }
  }

  ident = 'DEM' + tipDempera + sirinaDempera + visinaDempera + pogonDempera + osovinaDempera;
  return ident;
};


export const terUtilsGetIdentEliminatorKapi = (e) => {
  let ident = '';
  // ="ELK"&IF(I2="STANDARDNI","S","?")&IF(I3<1000,"0"&I3,I3)&IF(I4<1000,"0"&I4,I4)
  let tipEliminatoraKapi = '';
  let sirinaEliminatoraKapi = '';
  let visinaEliminatoraKapi = '';
  let brojKomada = '';

  if (e.tipeliminatorakapi && e.tipeliminatorakapi === 'standardni') {
    tipEliminatoraKapi = 1;
  }

  if (e.sirina) {
    sirinaEliminatoraKapi = e.sirina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    sirinaEliminatoraKapi = ('0000' + sirinaEliminatoraKapi).slice(-4);
  }

  if (e.visina) {
    visinaEliminatoraKapi = e.visina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    visinaEliminatoraKapi = ('0000' + visinaEliminatoraKapi).slice(-4);
  }

  ident = 'ELK' + tipEliminatoraKapi + sirinaEliminatoraKapi + visinaEliminatoraKapi;
  return ident;
};

export const terUtilsGetIdentSpoljnaFiksnaZaluzina = (s) => {
  // ="SPF"&IF(I2="STANDARDNI",1,"?")&IF(I3<1000,"0"&I3,I3)&IF(I4<1000,"0"&I4,I4)
  let ident = '';
  let tipspoljnefiksnezaluzine = '';
  let unutrasnjasirina = '';
  let unutrasnjavisina = '';
  let kolicina = '';

  if (s.tipspoljnefiksnezaluzine && s.tipspoljnefiksnezaluzine === 'standardni') {
    tipspoljnefiksnezaluzine = 1;
  } else {
    tipspoljnefiksnezaluzine = '?'
  }

  if (s.unutrasnjasirina) {
    unutrasnjasirina = s.unutrasnjasirina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    unutrasnjasirina = ('0000' + s.unutrasnjasirina).slice(-4);
  }

  if (s.unutrasnjavisina) {
    unutrasnjavisina = s.unutrasnjavisina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    unutrasnjavisina = ('0000' + s.unutrasnjavisina).slice(-4);
  }
  ident = 'SPF' + tipspoljnefiksnezaluzine + unutrasnjasirina + unutrasnjavisina;
  return ident;
};

export const terUtilsGetIdentElasticnaVeza = (e) => {
  //="ELV"&IF(I2="METZ 20",20,IF(I2="METZ 30",30,"?"))&IF(I4<1000,"0"&I4,I4)&IF(I5<1000,"0"&I5,I5)&IF(I3="STANDARDNA","S",IF(I3="VATROOTPORNA","V"))

  let ident = '';
  let prirubnica = '';
  let platno = '';
  let sirinaa = '';
  let visinab = '';
  let kolicina = '';


  if (e.prirubnica && e.prirubnica === 'METZ 20') {
    prirubnica = 20;
  } else if (e.prirubnica && e.prirubnica === 'METZ 30') {
    prirubnica = 30;
  } else {
    prirubnica = '?'
  }

  if (e.platno && e.platno === 'STANDARDNA') {
    platno = 'S';
  } else if (e.platno && e.platno === 'VATROOTPORNA') {
    platno = 'V';
  } else {
    platno = '?'
  }

  if (e.sirinaa) {
    sirinaa = e.sirinaa.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    sirinaa = ('0000' + e.sirinaa).slice(-4);
  } else {
    sirinaa = '?'
  }

  if (e.visinab) {
    visinab = e.visinab.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    visinab = ('0000' + e.visinab).slice(-4);
  } else {
    visinab = '?'
  }

  //="ELV"&IF(I2="METZ 20",20,IF(I2="METZ 30",30,"?"))&IF(I4<1000,"0"&I4,I4)&IF(I5<1000,"0"&I5,I5)&IF(I3="STANDARDNA","S",IF(I3="VATROOTPORNA","V"))
  ident = 'ELV' + prirubnica + sirinaa + visinab + platno;
  return ident;
};

export const terUtilsGetIdentPanel = (panel) => {
  let ident = '';

  let tipPanela = '';
  let sirinaPanela = '';
  let visinaPanela = '';

  if (panel.tippanela && panel.tippanela !== '') {
    tipPanela = panel.tippanela.toUpperCase();

  }

  if (panel.sirina && panel.sirina !== '') {
    sirinaPanela = panel.sirina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    sirinaPanela = ('0000' + sirinaPanela).slice(-4);
  }

  if (panel.visina && panel.visina !== '') {
    visinaPanela = panel.visina.toString();
    // Mora uvek da prikaze 4 cifre. Mora 0 na pocetku ako je manji od 1000 
    visinaPanela = ('0000' + visinaPanela).slice(-4);
  }

  ident = 'PAN' + tipPanela + sirinaPanela + visinaPanela;
  // return ident;

  // Treba da se generise iz genus biblioteke
  return "PAN000001";
};

// DRUGO...

/*
export const terUtilsDetectMaxSubkey = (arr, n) => {
  // detect largest integer used as .subkey property
  let max = 0;
  if (Number.parseInt(n) > max) {
    max = Number.parseInt(n) + 1;
  }
  arr.forEach(item => {
    if (item && Number.parseInt(item.subkey) > max) {
      max = Number.parseInt(item.subkey);
    }
  });
  return maxSubkey;
};
*/


//
export const terUtils_odredi_novi_broj_modula = (parent_subkey, smartbom) => {
  const _draftelschemakey = 'terkk$modul';
  let brojSledecegModula = 1;
  let nizBrojevaModula = [];
  let count = 0;
  if (_smartbom_validator_quick_incomplete(smartbom)) {
    const _kk_children_smartel_arr = _smartbom_manipulator_get_children_smartel_arr(smartbom, parent_subkey);
    // prebrojava...
    let pronadjen = false;
    _kk_children_smartel_arr.forEach(smartel => {
      if (smartel && smartel.self && smartel.self.draftel && smartel.self.draftel._draftelschemakey === _draftelschemakey) {
        count++;
        pronadjen = true;
        nizBrojevaModula.push(smartel.self.draftel.brojmodula);
      }
    });
    // Ako niz nije prazan onda trazimo sledeci, ako je prazan vratice 1
    if (_kk_children_smartel_arr.length > 0) {
      // Nadji max broj modula
      let maxBrojModula = Math.max(...nizBrojevaModula);
      // console.log('max ', maxBrojModula);
      brojSledecegModula = maxBrojModula + 1;
    }
  }
  return brojSledecegModula;
};


//
export const terUtilsPrebrojDraftele_where_parent_subkey_and_draftelschemakey = (parent_subkey, _draftelschemakey, smartbom) => {
  let count = 0;
  if (_smartbom_validator_quick_incomplete(smartbom)) {
    const _children_smartel_arr_filtered = _smartbom_manipulator_get_children_smartel_arr(smartbom, parent_subkey);
    // prebrojava...
    let pronadjen = false;
    _children_smartel_arr_filtered.forEach(smartel => {
      if (smartel && smartel.self && smartel.self.draftel && smartel.self.draftel._draftelschemakey === _draftelschemakey) {
        count++;
        pronadjen = true;
      }
    });
  }
  return count;
};


//
export const terUtilsExtractKlimaKomoraMeta = (smartbom) => {
  // let meta_ident = entbox_za_komoru.sifrakomore;
  // let meta_naziv = entbox_za_komoru.nazivsistema;
  let sifrakomore = null;
  let nazivsistema = null;
  let meta_ukupno_modula = null;
  if (_smartbom_validator_quick_incomplete(smartbom)) {
    meta_ukupno_modula = _smartbom_manipulator_count_draftels_where_draftelschemakey(smartbom, "terkk$modul");
    const _children_smartel_arr_filtered = _smartbom_manipulator_get_children_smartel_arr(smartbom, null);
    // console.log('_children_smartel_arr_filtered', _children_smartel_arr_filtered);
    // prebrojava...
    let pronadjen = false;
    const _draftelschemakey = "terkk$klimakomora";
    _children_smartel_arr_filtered.forEach(smartel => {
      if (smartel && smartel.self && smartel.self.draftel && smartel.self.draftel._draftelschemakey === _draftelschemakey) {
        pronadjen = true;
        sifrakomore = smartel.self.draftel.sifrakomore;
        nazivsistema = smartel.self.draftel.nazivsistema;
      }
    });
  }
  return {
    sifrakomore,
    nazivsistema,
    meta_ukupno_modula,
  };
};


/*
export const terUtilsPrebrojPoluproizvod_bundle_panel = (parent_subkey, draftel_arr) => {
  // prebrojava broj panela tacnije, broj panela koji zive kao zasebni poluproizvod itemi u nizu poluproizvoda 
  let count = 0;
  let pronadjen = false;
  draftel_arr.forEach(p => {
    if (p.parent_subkey === parent_subkey && p._draftelschemakey === 'terkk$_bundle_panel') {
      count++;
      pronadjen = true;
    }
  });
  return count;
};
*/

/*
export const terUtilsPrebrojPoluproizvod_bundle_eliminatorkapi = (parent_subkey, draftel_arr) => {
  // prebrojava broj panela tacnije, broj panela koji zive kao zasebni poluproizvod ittemi u nizu poluproizvoda 
  let count = 0;
  let pronadjen = false;
  draftel_arr.forEach(p => {
    if (p.parent_subkey === parent_subkey && p._draftelschemakey === 'terkk$_bundle_eliminatorkapi') {
      count++;
      pronadjen = true;
    }
  });
  return count;
};
*/

/*
export const terUtilsPrebrojPoluproizvod_bundle_postolje = (parent_subkey, draftel_arr) => {
  // prebrojava broj postolja....
  let count = 0;
  let pronadjen = false;
  draftel_arr.forEach(p => {
    if (p.parent_subkey === parent_subkey && p._draftelschemakey === 'terkk$_bundle_postolje') {
      count++;
      pronadjen = true;
    }
  });
  return count;
};
*/


export const terUsernameById = (id) => {
  let username;
  const korisnici = users_cache_get();
  if (Array.isArray(korisnici)) {
    korisnici.forEach((item) => {
      if (item.id === id) {
        if (typeof item.display_name === 'string' && item.display_name !== '') {
          username = item.display_name
        } else {
          username = item.username;
        }
      }
    });
  }
  return username;
};


export const terUserDisplayNameById = (id) => {
  let display_name;
  const korisnici = users_cache_get();
  if (Array.isArray(korisnici)) {
    korisnici.forEach((item) => {
      if (item.id === id) {
        display_name = item.display_name;
      }
    });
  }
  return display_name;
};


//
export const terUtils_2d_panel_dimenziona_sifra_materijala_iz_bezdimenzione = (bezdimenziona_sifra_materijala, duzina, sirina) => {
  let _bezdimenziona_sifra_materijala = '?';
  if (typeof bezdimenziona_sifra_materijala === 'string') {
    _bezdimenziona_sifra_materijala = bezdimenziona_sifra_materijala;
  }
  let _duza = duzina;
  let _kraca = sirina;
  if (js_utils.is_number(duzina) && js_utils.is_number(sirina)) {
    if (js_utils.is_number(duzina) < js_utils.is_number(sirina)) {
      _duza = sirina;
      _kraca = duzina;
    }
  } else {
    if (js_utils.is_number(duzina)) {
      _duza = duzina;
      _kraca = sirina;
    } else {
      _duza = sirina;
      _kraca = duzina;
    }
  }
  if (js_utils.is_number(_duza)) {
    _duza = ('0000' + Number.parseInt(_duza)).slice(-4);
  } else {
    _duza = '?';
  }
  if (js_utils.is_number(_kraca)) {
    _kraca = ('0000' + Number.parseInt(_kraca)).slice(-4);
  } else {
    _kraca = '?';
  }
  const dimenziona_sifra_materijala = _bezdimenziona_sifra_materijala + _duza + _kraca;
  return dimenziona_sifra_materijala;
};


//
export const terUtils_2d_panel_bezdimenziona_sifra_materijala_iz_dimenzione = (dimenziona_sifra_materijala) => {
  let bezdimenziona_sifra_materijala = '?';
  if (typeof dimenziona_sifra_materijala === 'string') {
    bezdimenziona_sifra_materijala = dimenziona_sifra_materijala.substring(0, (dimenziona_sifra_materijala.length - 8)); // oduzimamo 8 charactera sa desne strane
  }
  return bezdimenziona_sifra_materijala;
};


//
export const terUtils_1d_profil_dimenziona_sifra_materijala_iz_bezdimenzione = (bezdimenziona_sifra_materijala, duzina) => {
  let _bezdimenziona_sifra_materijala = '?';
  if (typeof bezdimenziona_sifra_materijala === 'string') {
    _bezdimenziona_sifra_materijala = bezdimenziona_sifra_materijala;
  }
  let _duza = duzina;
  if (js_utils.is_number(_duza)) {
    _duza = ('0000' + Number.parseInt(_duza)).slice(-4);
  } else {
    _duza = '?';
  }
  const dimenziona_sifra_materijala = _bezdimenziona_sifra_materijala + _duza;
  return dimenziona_sifra_materijala;
};


//
export const terUtils_1d_profil_bezdimenziona_sifra_materijala_iz_dimenzione = (dimenziona_sifra_materijala) => {
  let bezdimenziona_sifra_materijala = '?';
  if (typeof dimenziona_sifra_materijala === 'string') {
    bezdimenziona_sifra_materijala = dimenziona_sifra_materijala.substring(0, (dimenziona_sifra_materijala.length - 4)); // oduzimamo 4 charactera sa desne strane
  }
  return bezdimenziona_sifra_materijala;
};

